import extend from 'lodash/extend';
import objectPrefix from '../lib/objectPrefix';

module.exports = extend(
    require('./partials/introCharacters'),
    require('./partials/portraits'),
    require('./partials/title'),
    require('./partials/blob'),
    // require('./general/faces'),
    // require('./partials/machine'),
    // require('./partials/slideshow'),
    require('./general/tiles'),
    {
        // introBg: {
        //     texture: 'sprite:/img/scenes/intro/intro-'+objectPrefix()+'.json,intro/intro-bg.jpg',
        //     scale: {
        //         x: '100%',
        //     },
        // },

        introBg: {
            texture: 'sprite:/img/partials/intro-jpegs.json,intro-jpegs/intro-bg-small.jpg',
            scale: {
                x: '100%',
            },
        },

        kraftBackground: {
            scale: {
                y: '100%',
            },
            position: {
                x: '0%',
                y: '0%',
            },
            texture: 'sprite:/img/partials/intro-jpegs.json,intro-jpegs/kraft-bg-small.jpg',
        },

        pipes: {
            texture: 'sprite:/img/scenes/intro/intro-'+objectPrefix()+'.json,intro/pipes.png',
            position: {
                x: '50%',
                y: '0%',
            },
            scale: {
                x: '100%',
            },
            anchor: {
                x: 0.5,
                y: 0,
            },
        },

        pipesCentered: {
            texture: 'sprite:/img/scenes/intro/intro-'+objectPrefix()+'.json,intro/pipes.png',
            position: {
                x: '0%',
                y: '0%',
            },
            scale: {
                x: '100%',
            },
            anchor: {
                x: 0,
                y: 0,
            },
        },

        dirt: {
            texture: 'sprite:/img/scenes/intro/intro-'+objectPrefix()+'.json,intro/dirt.png',
            scale: {
                x: '100%',
            },
        },

        titleTextTexture: {
            texture: 'sprite:/img/scenes/intro/intro-'+objectPrefix()+'.json,intro/title-text-texture.png',
            position: {
                x: '0%',
                y: '0%',
            },
            scale: {
                x: '100%',
                y: '100%',
            },
        },

        titleTextMask: {
            texture: '/img/scenes/intro/title-text-mask.png',
            position: {
                x: '5%',
                // y: '36.5%'
                y: '33%',
            },
            scale: {
                x: '70%',
            },
        },

        titleTextMaskFr: {
            texture: '/img/scenes/intro/title-text-mask-2-fr.png',
            position: {
                x: '5%',
                // y: '36.5%'
                y: '33%',
            },
            scale: {
                x: '70%',
            },
        },

        titleText: {
            texture: '/img/scenes/intro/title-text.png',
            position: {
                x: '5%',
                // y: '36.5%'
                y: '33%',
            },
            scale: {
                x: '70%',
            },
        },

        titleTextFr: {
            texture: '/img/scenes/intro/title-text-fr.png',
            position: {
                x: '5%',
                // y: '36.5%'
                y: '33%',
            },
            scale: {
                x: '70%',
            },
        },
    },
);



// WEBPACK FOOTER //
// ./js/objects/intro.js